import axios from '../erp/configAxiosClean';

export const getTerminalUsersApi = async (terminal_id) => {
	return await axios.get(`/users/?&limit=100&offset=0&terminal=${Number(terminal_id)}&user_type=1`);
};
